<template>
  <div class="orderContiner">
    <div class="containter" v-loading='loading'>
      <div class="topOperation clear">
        <self-back :pageHeaderList="[{ 'name': '月度订单审核', 'path': '/examine' }, { 'name': month + '审核订单表' }]"
          style="float:left;margin:0;margin-right:15px;"></self-back>
        <a class="buttonExprt"
          :href="URL.BASEURL + URL.orderEditingExport + `?verify_status=${tab}&month=${month}&customer_name=${customer_name}&admin_id=${JSON.parse($cookie.getCookie('userInfo')).admin_id}&ttl=${JSON.parse($cookie.getCookie('userInfo')).ttl}&sign=${JSON.parse(this.$cookie.getCookie('userInfo')).sign}&approved_start_date=${approved_date && approved_date.length > 0 ? approved_date[0] : ''}&approved_end_date=${approved_date && approved_date.length > 0 ? approved_date[1] : ''}&task_id=${task_id}&company=${company}`"><i
            class="el-icon-download" style="margin-right:5px;"></i>导出修改记录</a>

        <a class="buttonExprt" v-if="userInfo.role_id == 12 || userInfo.role_id == 22"
          :href="URL.BASEURL + URL.monthEditList + `?month=${month}&admin_id=${JSON.parse($cookie.getCookie('userInfo')).admin_id}&ttl=${JSON.parse($cookie.getCookie('userInfo')).ttl}&sign=${JSON.parse(this.$cookie.getCookie('userInfo')).sign}`">
          <i class="el-icon-download" style="margin-right:5px;"></i>导出当月提交修改记录
        </a>
        <el-select style="float:right;width:160px" v-model="customer_name" size='mini' :clearable='true' filterable
          placeholder="请选择客户全称">
          <el-option v-for="(item, index) in customerList" :key="index" :label="item.customer_name"
            :value="item.customer_name">
          </el-option>
        </el-select>
        <div class="selectBox clear" style="float:right;margin:6px 20px 0;">
          <div :class="['selectItem', tab == item.id ? 'active' : '']" @click="examineTab(item.id)"
            v-for="(item, index) in examineList" :key="index">
            <div class="icon"></div>{{ item.name }}
          </div>
        </div>
      </div>
      <div class="tableBox">
        <div class="conditionBox">
          <div class="batchDelete" style="background:#d51414;border-color:#d51414" @click="batchDelete">批量审核</div>
          <div class="conditionItem">
            <label>财务审核时间：</label>
            <el-date-picker style="width:240px" v-model="approved_date" type="daterange" value-format="yyyy-MM-dd"
              size='mini' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div class="conditionItem">
            <label>任务ID：</label>
            <el-input placeholder="请输入任务ID" v-model.trim="task_id" clearable
              @keydown.enter.native="task_id ? getOrderEditing(1) : ''" @clear="getOrderEditing(1)" size="mini"
              style="width:200px">
              <el-button slot="append" icon="el-icon-search" @click="task_id ? getOrderEditing(1) : ''"
                style="padding:0 10px"></el-button>
            </el-input>
          </div>
          <div class="conditionItem">
            <label>签约公司：</label>
            <el-select v-model="company" style="width:200px" size='mini' clearable @change="getOrderEditing(1)" filterable
              placeholder="请输入签约公司名称">
              <el-option v-for="(item, index) in signCompanyList" :key="index" :label="item.company"
                :value="item.company">
              </el-option>
            </el-select>
          </div>
          <div class="conditionItem">
            <label>mcn机构：</label>
            <el-select style="width:160px" v-model="mcn_name" size='mini' @change="getOrderEditing(1)" :clearable='true'
              filterable placeholder="请选择mcn机构">
              <el-option v-for="(item, index) in mcnList" :key="index" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
          <div class="conditionItem">
            <label>成本公司：</label>
            <el-select style="width:160px" v-model="cost_company_name" size='mini' @change="getOrderEditing(1)"
              :clearable='true' filterable placeholder="请选择成本公司">
              <el-option v-for="(item, index) in costCompanysList" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="conditionItem">
            <template v-if="userInfo.role_id == 10 || userInfo.role_id == 18 || userInfo.role_id == 17 || userInfo.role_id == 21">
              <el-select v-model="pre_audit_status" @change="getOrderEditing(1)" style="width:150px;margin-right:15px;" size="mini"
                clearable placeholder="财务预审状态">
                <el-option v-for="(item, index) in pre_audit_list" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </div>

        </div>
        <el-table :data="orderList" ref="multipleTable" border row-key="id" @selection-change="handleSelectionChange"
          style="width: 100%" class="thwordHidden" height="calc(100vh - 242px)">
          <el-table-column type="selection" align="center" :selectable='checkSelectable' :reserve-selection="true"
            width="45">
          </el-table-column>
          <el-table-column :min-width="item.width + 'px'" align="center" label-class-name="thAE"
            :fixed="item.fixed ? true : false" :prop="'order.' + item.prop" :label="item.label" show-overflow-tooltip
            v-for="(item, index) in columns" :key="index"></el-table-column>
          <el-table-column min-width="96px" align="center" label="商务/媒介审核时间">
            <template slot-scope="scope">
              <div style="line-height: 14px;">{{ scope.row.verify_at }}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="96px" align="center" label="财务审核时间">
            <template slot-scope="scope">
              <div style="line-height: 14px;">{{ scope.row.final_verify_at }}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="96px" align="center" label="预审结果" fixed="right" v-if="userInfo.role_id == 18 || userInfo.role_id == 10 || userInfo.role_id == 17 || userInfo.role_id == 21">
            <template slot-scope="scope">
              <div style="line-height: 14px;" v-if="scope.row.pre_audit_status == 1">{{ '通过' }}</div>
              <div style="line-height: 14px;color:#d51313;" v-if="scope.row.pre_audit_status == 2">{{ `驳回` }}
                <el-popover placement="left-end" title="预审意见" width="400" trigger="hover" :content="scope.row.pre_audit_content">
                  <i class="el-icon-view" slot="reference" style="color: #202652;"></i>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="80px" align="center" label="状态" fixed="right">
            <template slot-scope="scope">
              <div class="statusBox">
                <span v-if="scope.row.data_type == 1">
                  <!-- 媒介待审核 -->
                  <span v-if="!scope.row.mj_status && scope.row.mj_status != 0">商务待审核</span>
                  <!-- 媒介审核未通过 -->
                  <span v-else-if="scope.row.mj_status == 2" style="color:#d51313;">商务审核未通过</span>
                  <!-- 媒介审核通过、财务未审核 -->
                  <span v-else-if="scope.row.mj_status == 1 && (!scope.row.cw_status && scope.row.cw_status != 0)"
                    style="color:#EF7400">财务待审核(商务审核通过)</span>
                  <!-- 媒介审核通过、财务审核未通过 -->
                  <span v-else-if="scope.row.mj_status == 1 && scope.row.cw_status == 2"
                    style="color:#d51313;">财务审核未通过(商务审核通过)</span>
                  <!-- 媒介审核通过、财务审核通过 -->
                  <span v-else-if="scope.row.mj_status == 1 && scope.row.cw_status == 1"
                    style="color:#00BB5D;">审核通过</span>
                </span>
                <span v-else>
                  <!-- 媒介待审核 -->
                  <span v-if="!scope.row.mj_status && scope.row.mj_status != 0">媒介待审核</span>
                  <!-- 媒介审核未通过 -->
                  <span v-else-if="scope.row.mj_status == 2" style="color:#d51313;">媒介审核未通过</span>
                  <!-- 媒介审核通过、财务未审核 -->
                  <span v-else-if="scope.row.mj_status == 1 && (!scope.row.cw_status && scope.row.cw_status != 0)"
                    style="color:#EF7400">财务待审核(媒介审核通过)</span>
                  <!-- 媒介审核通过、财务审核未通过 -->
                  <span v-else-if="scope.row.mj_status == 1 && scope.row.cw_status == 2"
                    style="color:#d51313;">财务审核未通过(媒介审核通过)</span>
                  <!-- 媒介审核通过、财务审核通过 -->
                  <span v-else-if="scope.row.mj_status == 1 && scope.row.cw_status == 1"
                    style="color:#00BB5D;">审核通过</span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="80px" align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <!-- 媒介审核 -->
              <span v-if="userInfo.role_id == 13 || userInfo.role_id == 15">
                <span style="color:#5B7BFE;cursor: pointer;" v-if="!scope.row.mj_status && scope.row.mj_status != 0"
                  @click="examineEvent(scope.row)">{{ scope.row.is_batch == 1 ? '批量审核' : '审核' }}</span>
                <span style="color:#5B7BFE;cursor: pointer;" v-else
                  @click="() => { order_id = scope.row.order_id; record_id = scope.row.id; journalFlag = true; }">查看</span>
              </span>
              <!-- 财务审核 -->
              <span v-else-if="userInfo.role_id == 10 || userInfo.role_id == 18 || userInfo.role_id == 17 || userInfo.role_id == 21">
                <span style="color:#5B7BFE;cursor: pointer;"
                  v-if="scope.row.mj_status == 1 && (!scope.row.cw_status && scope.row.cw_status != 0)"
                  @click="examineEvent(scope.row)">{{ scope.row.is_batch == 1 ? '批量审核' : '审核' }}</span>
                <span style="color:#5B7BFE;cursor: pointer;" v-else
                  @click="() => { order_id = scope.row.order_id; record_id = scope.row.id; journalFlag = true; }">查看</span>
              </span>
              <span style="color:#5B7BFE;cursor: pointer;" v-else
                @click="() => { order_id = scope.row.order_id; record_id = scope.row.id; journalFlag = true; }">查看</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="listBox">
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size"
            @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="订单审核" top="7vh" width="1000px" :visible.sync="examineFlag" :close-on-click-modal='false'>
      <examine-toast :examineInfo='examineInfo' @emit_refresh='emit_refresh' @cancelToast='cancelToast'
        v-if="examineFlag"></examine-toast>
    </el-dialog>
    <!-- 查看日志 -->
    <el-dialog title="订单记录" :visible.sync="journalFlag" width="60%" top="10vh" :close-on-click-modal='false'>
      <journal v-if="journalFlag" @cancelToast='cancelToast' :order_id='order_id' :record_id='record_id'></journal>
    </el-dialog>
    <!-- 批量审核pdd -->
    <el-dialog title="批量审核" :visible.sync="batchExaminePddFlag" width="80%" top="10vh" :close-on-click-modal='false'>
      <batch-examine-pdd v-if="batchExaminePddFlag" :edit_id='edit_id' @emit_refresh='emit_refresh'
        @cancelToast='cancelToast'></batch-examine-pdd>
    </el-dialog>
    <!-- 批量审核 -->
    <el-dialog title="批量审核" :visible.sync="batchExamineFlag" width="80%" top="10vh" :close-on-click-modal='false'>
      <batch-examine v-if="batchExamineFlag" :edit_ids='edit_ids' @emit_refresh='emit_refresh'
        @cancelToast='cancelToast'></batch-examine>
    </el-dialog>
  </div>
</template>
<script>
import columnsJson from '@/components/Order/json/total.js'
import examineToast from './examineToast'
import journal from '@/components/Order/orderJournal'
import batchExaminePdd from './batchExaminePdd'
import batchExamine from './batchExamine'
export default {
  components: {
    examineToast,
    journal,
    batchExaminePdd,
    batchExamine
  },
  data () {
    return {
      page: 1,
      page_size: 50,
      total: 0,
      loading: false,
      tab: 0,
      month: '',
      orderList: [],
      userInfo: {},
      examineFlag: false,
      examineInfo: {},
      journalFlag: false,
      order_id: '',
      customerList: [],
      customer_name: '',
      batchExaminePddFlag: false,
      edit_id: '',
      record_id: '',//记录ID
      columns: columnsJson,
      multipleSelection: [],
      batchExamineFlag: false,
      edit_ids: [],
      examineList: [
        { name: '全部', id: 0 },
        { name: '待审核', id: 1 },
        { name: '审核通过', id: 2 },
        { name: '审核未通过', id: 3 }
      ],
      approved_date: [],
      task_id: '',
      signCompanyList: [],
      company: '',
      mcnList: [],
      mcn_name: '',
      cost_company_name: '',
      costCompanysList: [],
      pre_audit_status: '',
      pre_audit_list: [
        { label: '待审核', value: 0 },
        { label: '审核通过', value: 1 },
        { label: '审核驳回', value: 2 },
      ]
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    if (this.$route.params.month) {
      this.month = this.$route.params.month;
    }
    this.costCompanys()
    this.mcnListEvent()
    this.customerListEvent();
    this.getSignCompany()
  },
  mounted () {
    this.getOrderEditing(1)
  },
  methods: {
    examineTab (tab) {
      this.$refs.multipleTable.clearSelection();//清空用户选择
      this.tab = tab;
      this.getOrderEditing(1)
    },
    batchDelete () {//批量审核
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择要审核的订单',
          type: 'warning'
        })
        return
      }
      var arr = [];
      this.multipleSelection.forEach((item) => {
        arr.push(item.id)
      })
      this.edit_ids = arr;
      this.batchExamineFlag = true
    },
    checkSelectable (row) {//锁单的不可删除
      if ( this.userInfo.role_id == 10 || this.userInfo.role_id ==17 || this.userInfo.role_id ==21) { // 财务
        return (row.mj_status == 1 && (!row.cw_status && row.cw_status != 0) && row.is_batch != 1)
      } else if (this.userInfo.role_id == 13 || this.userInfo.role_id == 15) {
        return (!row.mj_status && row.mj_status != 0 && row.is_batch != 1)
      } else if (this.userInfo.role_id == 18){ // 财务预审
        return (!row.pre_audit_status && row.mj_status == 1 && (!row.cw_status && row.cw_status != 0) && row.is_batch != 1)
      } else {
        return false
      }
      // return (this.userInfo.role_id == 10 || this.userInfo.role_id == 18) ? (row.mj_status == 1 && (!row.cw_status && row.cw_status != 0) && row.is_batch != 1) : (this.userInfo.role_id == 13 || this.userInfo.role_id == 15 ? (!row.mj_status && row.mj_status != 0 && row.is_batch != 1) : false)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    examineEvent (data) {//审核
      if (data.is_batch == 1) {//批量审核
        this.batchExaminePddFlag = true;
        this.edit_id = data.id;
        return;
      }
      var data = data;
      // 把更改的值为null的改为''
      if (!data.order_origin) {
        data.order_origin = {}
      } else {
        for (var i in data.order_origin) {
          if (!data.order_origin[i] && data.order_origin[i] != 0) {
            data.order_origin[i] = '';
          }
        }
      }
      this.examineInfo = data;
      this.examineFlag = true
    },
    cancelToast () {
      this.examineFlag = false;
      this.batchExaminePddFlag = false;
      this.batchExamineFlag = false;
      this.journalFlag = false;
    },
    emit_refresh () {//刷新列表
      this.examineFlag = false;
      this.batchExaminePddFlag = false;
      this.batchExamineFlag = false;
      this.$refs.multipleTable.clearSelection();//清空用户选择
      this.getOrderEditing(this.page)
    },
    handleCurrentChange (val) {
      this.getOrderEditing(val)
    },
    getOrderEditing (page) {
      var page = page;
      var page_size = this.page_size;
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.getOrderEditing, {
        params: {
          page: page,
          pagesize: page_size,
          verify_status: this.tab,
          month: this.month,
          customer_name: this.customer_name,
          approved_start_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[0] : '',
          approved_end_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[1] : '',
          task_id: this.task_id,
          company: this.company,
          mcn_name: this.mcn_name,
          cost_company_name: this.cost_company_name,
          pre_audit_status: this.pre_audit_status
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.orderList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    mcnListEvent (page) {
      this.$axios.get(this.URL.BASEURL + this.URL.mcnList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.mcnList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    costCompanys () {//成本公司全程列表
      this.$axios.get(this.URL.BASEURL + this.URL.costCompanys, {
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.costCompanysList = res.rst;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    customerListEvent () {
      this.$axios.get(this.URL.BASEURL + this.URL.customerList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.customerList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    getSignCompany () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.signCompanyList = res.rst.data;
        } else {
        }
      }).catch(() => {
      })
    },
  },
  watch: {
    customer_name () {
      this.$refs.multipleTable.clearSelection();//清空用户选择
      this.getOrderEditing(1)
    },
    approved_date () {
      this.getOrderEditing(1)
    }
  }
}
</script>
<style lang="scss" scoped>
.containter {
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);

  .topOperation {
    padding: 16px 16px;
    padding-bottom: 6px;
    margin-top: 10px;

    .title {
      font-size: 15px;
      color: #202652;
      line-height: 21px;
      font-weight: 500;
      display: inline-block;
      vertical-align: middle;
    }

    .selectBox {
      display: inline-block;
      vertical-align: middle;

      .selectItem {
        float: left;
        font-size: 13px;
        margin-left: 20px;
        cursor: pointer;

        .icon {
          width: 13px;
          height: 13px;
          border-radius: 3px;
          border: 1px solid #d2d2d2;
          display: inline-block;
          vertical-align: bottom;
          margin-right: 3px;
        }

        &.active {
          .icon {
            border-color: #2662ff;
            position: relative;

            &::before {
              content: "";
              display: inline-block;
              width: 7px;
              height: 7px;
              background: #2662ff;
              border-radius: 1px;
              position: absolute;
              top: 2px;
              left: 2px;
            }
          }
        }
      }
    }
  }
}

.tableBox {
  margin: 0 16px 0;
}

.conditionBox {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;

  .conditionItem {
    margin-left: 10px;
    display: flex;
    align-items: center;
    margin-top: 3px;
  }

  label {
    font-size: 13px;
  }
}

.statusBox {
  width: 120%;
  transform: scale(0.9);
  margin-left: -10%;
  height: 100%;
}

.buttonExprt {
  background: #5B7BFE;
  color: #FFFFFF;
  border: 1px solid #5B7BFE;
  float: right;
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 4px;
  margin-left: 10px;
  line-height: 18px;
}

.batchDelete {
  width: 80px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #5B7BFE;
  background: #5B7BFE;
  color: #fff;
  cursor: pointer;
  padding: 0 4px;
}
</style>
<style lang="scss">
.orderContiner {
  .thAE {
    background: #E3E9F3 !important;
  }

  .thMedium {
    background: #F6E6E6 !important;
  }

  .thFinance {
    background: #E6F3F3 !important;
  }

  .thTotal {
    background: #eff0f2 !important;
  }

  .el-table {
    font-size: 12px !important;
  }

  .el-date-editor .el-range-separator {
    width: 10%;
  }

  .el-input--suffix .el-input__inner {
    padding-right: 10px !important;
  }

  .el-table th>.cell {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  .el-table td,
  .el-table th {
    padding: 5px 0 !important;
  }

  .numberInput .el-input__inner {
    padding: 0 4px !important;
    text-align: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/examine/monthDetail.vue